import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { SeleccionService } from '../../servicios/seleccion.service';
import { ToolsService } from '../../recursos/tools.service';
import { IngresoService } from '../../servicios/ingreso.service';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { Router } from '@angular/router';
import { configuracion } from '../../recursos/config.service';
import { recursosBecas } from 'src/app/recursos/interfaz';
import { recursosCompartido } from 'src/app/recursos/cosumoGeneral.service';
import { SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-postula-becario',
  templateUrl: './postula-becario.component.html',
  styleUrls: ['./postula-becario.component.css']
})
export class PostulaBecarioComponent implements OnInit {

  public mr: NgbModalRef;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptionsGen: DataTables.Settings = {};
  dtOptionsEsp: DataTables.Settings = {};
  public dtTriggerGen: Subject<any>;
  public dtTriggerEsp: Subject<any>;

  public nombreBeca: string = ""; public observaRequisito: string = '';
  public vecReqGeneral = []; public vecReqEspecifico = []; public vecAjustes: Array<any> = [];
  private totalReq: number = 0; private tokenDrive: string = '';
  public rutaCarga: SafeResourceUrl | undefined; public enlaceCarga: string = '';

  constructor(private cargando: LoaderComponent, private srvSelect: SeleccionService, private tools: ToolsService, private confMensaje: configuracion,
    private srvGeneral: recursosCompartido, private modalService: NgbModal, private srvInsert: IngresoService, private alerti: AlertifyService, private recBecas: recursosBecas) { }

  async ngOnInit() {
    this.tokenDrive = '';
    this.nombreBeca = (localStorage.getItem('localNomBeca'));

    this.dtTriggerGen = new Subject<any>();
    this.dtTriggerEsp = new Subject<any>();
    this.dtOptionsGen[0] = this.tools.OpcionesTabla(10);
    this.dtOptionsEsp[0] = this.tools.OpcionesTabla(10);
    this.cargarPostulacion();
    this.cargarReqEspecifico();
    this.tokenDrive = await this.srvGeneral.getTokenLocal();
  }
  //FUNCION QUE CARGA TODOS LOS REQUSITOS QUE DEBE CUMPLIR EL BECARIO PARA LA BECA SELECCIONADA
  async cargarPostulacion() {
    //OBTENER EL TOTAL DE REQUISITO PARA UNA POSTULACIÓN
    const resRequisito = await new Promise<any>(resolve =>
      this.srvSelect.gestionRequisitos(8, localStorage.getItem('localIdBeca'), localStorage.getItem('localTipoBeca'), localStorage.getItem('localBecaPer')).subscribe(translated => {
        resolve(translated)
      }));
    this.totalReq = resRequisito['success'] == true ? resRequisito.especifico.length : 0;
    //OBTENER LOS AJUSTES DE LA BECA
    this.vecAjustes = [];
    const resAjuste = await new Promise<any>(resolve =>
      this.srvSelect.gestionBecas(14, localStorage.getItem('localIdBeca'), localStorage.getItem('localBecaPer'), 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resAjuste.success)
      this.vecAjustes.push({ resultado: true, ajuste: resAjuste.becas })
    else
      this.vecAjustes.push({ resultado: false })
  }
  //FUNCION QUE CARGA LOS REQUISITOS ESPECIFICOS QUE APLICA EL POSTULANTE
  async cargarReqEspecifico() {
    this.cargando.abrir();
    var table2 = $('#tblGeneral').DataTable({
      destroy: true
    });
    table2.destroy();
    this.vecReqGeneral = [];
    var reqDocumento = ''; var reqCumple = 2; var reqEdita = 0; var reqObserva = '';
    const resGen = await new Promise<any>(resolve =>
      this.srvSelect.gestionRequisitos(10, localStorage.getItem('localTipoBeca'), localStorage.getItem('localBecaPer'), 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resGen.success) {
      for (let objGen of resGen.especifico) {
        if (objGen.genEstado == 1) {
          const resPost = await new Promise<any>(resolve =>
            this.srvSelect.gestionPostulantes(5, localStorage.getItem('localBecaIdA'), objGen.becaId, objGen.reqId, 'na').subscribe(translated => {
              resolve(translated)
            }));
          if (resPost.success) {
            reqDocumento = resPost.postula[0]['strDocumento'];
            reqEdita = resPost.postula[0]['intAceptado'];
            reqCumple = resPost.postula[0]['intEstado'];
            reqObserva = resPost.postula[0]['strObservaciones'];
          }
          else {
            reqDocumento = ''; reqCumple = 2; reqEdita = 0;
          }
          this.vecReqGeneral.push({
            idRequisito: objGen.reqId, idBeca: objGen.becaId, nombre: objGen.reqNombre, edita: reqEdita,
            lblEdita: reqEdita == 1 ? 'ACEPTADO' : reqEdita == 3 ? 'POR EVALUAR' : reqEdita == 0 ? 'AGREGAR' : 'EDITAR', observa: reqObserva,
            describe: objGen.reqDetalle, cumpleReq: reqCumple, valorDoc: reqDocumento, habilita: objGen.formulario,
            enlaceForm: objGen.formulario != '' ? await this.srvGeneral.obtenerRutaPDF(this.tokenDrive, objGen.formulario) : '',
            cargaFile: reqEdita == 0 || reqEdita == 2 ? false : true, fuenteDato: objGen.intIdFuente
          })
        }
      }
      this.dtTriggerGen.next();
    }

    var table3 = $('#tblEspecifico').DataTable({
      destroy: true
    });
    table3.destroy();
    this.vecReqEspecifico = [];
    const resEsp = await new Promise<any>(resolve =>
      this.srvSelect.gestionRequisitos(1, localStorage.getItem('localIdBeca'), localStorage.getItem('localBecaPer'), 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resEsp.success) {
      for (let objEsp of resEsp.especifico) {
        if (objEsp.reqEstado == 1) {
          const resPost = await new Promise<any>(resolve =>
            this.srvSelect.gestionPostulantes(6, localStorage.getItem('localBecaIdA'), objEsp.intTipoBeca, objEsp.intIdRequisito, 'na').subscribe(translated => {
              resolve(translated)
            }));

          if (resPost.success) {
            reqDocumento = resPost.postula[0]['strDocumento'];
            reqEdita = resPost.postula[0]['intAceptado'];
            reqCumple = resPost.postula[0]['intEstado']
            reqObserva = resPost.postula[0]['strObservaciones'];
          }
          else {
            reqDocumento = ''; reqCumple = 2; reqEdita = 0; reqObserva = '';
          }
          this.vecReqEspecifico.push({
            idRequisito: objEsp.intIdRequisito, idBeca: objEsp.intTipoBeca, tipoBeca: objEsp.intTipoBeca, nombre: objEsp.strNombre, edita: reqEdita,
            lblEdita: reqEdita == 1 ? 'ACEPTADO' : reqEdita == 3 ? 'POR EVALUAR' : reqEdita == 0 ? 'AGREGAR' : 'EDITAR', observa: reqObserva,
            describe: objEsp.strDescripcion, cumpleReq: reqCumple, valorDoc: reqDocumento, periodo: objEsp.codPeriodo, habilita: objEsp.formulario,
            enlaceForm: objEsp.formulario != '' ? await this.srvGeneral.obtenerRutaPDF(this.tokenDrive, objEsp.formulario) : '',
            cargaFile: reqEdita == 0 || reqEdita == 2 ? false : true, fuenteDato: objEsp.intIdFuente
          })
        }
      }
      this.dtTriggerEsp.next();
    }
    this.cargando.cerrar();
  }
  //GUARDA O EDITA EL REQUISITO QUE EL POSTULANTE INGRESA
  guardarRequisito(objReq, cual, accion) {
    if (cual == 1) {
      this.srvInsert.ingresoGestionPostulante(localStorage.getItem('localBecaIdA'), objReq['idBeca'], objReq['idRequisito'], localStorage.getItem('localBecaPer'),
        objReq['valorDoc'], objReq['cumpleReq'], '', 3, accion == 'AGREGAR' ? 1 : 3).subscribe(res => {
          if (res.postula) {
            this.cargarReqCumplidos(localStorage.getItem('localBecaIdA'));
          }
        });
    }
    else {
      this.srvInsert.ingresoGestionPostulante(localStorage.getItem('localBecaIdA'), objReq.tipoBeca, objReq.idRequisito, objReq.periodo, objReq.valorDoc,
        objReq.cumpleReq, '', 3, accion == 'AGREGAR' ? 2 : 4).subscribe(res => {
          if (res.postula) {
            this.cargarReqCumplidos(localStorage.getItem('localBecaIdA'));
          }
        });
    }
  }
  //FUNCION QUE CARGA TODOS LOS REQUSITOS QUE HA INGRESADO EL BECARIO PARA LA BECA SELECCIONADA
  async cargarReqCumplidos(postula) {
    var totalPostula = 0;
    const resPostula = await new Promise<any>(resolve =>
      this.srvSelect.gestionRequisitos(9, postula, 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    totalPostula = resPostula['success'] == true ? resPostula.especifico.length : 0;
    if (totalPostula == this.totalReq)
      this.cambiaPostulacion(postula);
    else {
      this.alerti.success('Requisito agregado correctamente');
      window.location.reload();
    }
  }
  //FUNCION QUE DETERMINA SI EL PROCESO DE POSTULACION HA TERMINADO
  cambiaPostulacion(postula) {
    this.srvInsert.ingresoGestionBecas(postula, 1, 'na', 'na', 'na', 'na', 'na', 'na', 'na', "na", 'na', 'na', 'na', 'na', 13).subscribe(res => {
      if (res.becas)
        this.alerti.success('EL PROCESO DE POSTULACIÓN HA TERMINADO CON ÉXITO AHORA DEBE ESPERAR QUE UN ANALISTA DE BECAS REVISE EL SU POSTULACIÓN Y MEDIANTE EL CORREO INSTITUCIONAL SE LE NOTIFICARÁ EL ESTADO DE LA MISMA.')
      this.enviarCorreo();
    });
  }
  //FUNCION QUE PERMITE EL ENVÍO DE CORREOS
  async enviarCorreo() {
    let contenido = '';
    if (this.vecAjustes[0].resultado)
      contenido = this.confMensaje.bodyMensaje(15, localStorage.getItem('localUsuarioName'), localStorage.getItem('localNomBeca'), this.vecAjustes[0].ajuste[0].strMailCargaReq, 'na', 'na');

    this.srvInsert.envioMail('Postulación ' + localStorage.getItem('localNomBeca'), localStorage.getItem('localCorreo'), btoa(contenido)).subscribe(resEnvio => {
      if (resEnvio.correo)
        this.alerti.error("Error al enviar el correo electrónico");
      else
        window.location.reload();
    });
  }
  //FUNCION QUE ABRE EL MODAL PARA VER LAS OBSERVACIONES REALIZADAS POR EL ANALISTA DE BECAS
  verCambios(nombModal, observa) {
    this.observaRequisito = observa['observa'];
    this.mr = this.modalService.open(nombModal);
  }
  //FUNCION QUE CIERRA EL MODAL
  cerrarModal() {
    this.mr.close();
  }
  //FUNCION PARA CARGAR UN PDF AL DRIVE
  async cargandoArchivos(evento, objPostula, op) {
    //OBTENER LOS AJUSTES DE LA BECA
    this.vecAjustes = [];
    const resAjuste = await new Promise<any>(resolve =>
      this.srvSelect.gestionBecas(14, localStorage.getItem('localIdBeca'), localStorage.getItem('localBecaPer'), 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resAjuste.success) {

      let banCarga = 0;
      if (resAjuste.becas[0].vigenteCarga > 0)
        banCarga = 1;
      if ((resAjuste.becas[0].vigenteCarga <= 0) && objPostula.edita == 2)
        banCarga = 2
      if (banCarga > 0) {
        this.cargando.abrir();
        this.tokenDrive = await this.srvGeneral.getTokenLocal();
        let rutaCarga = '';
        if (op == 1)
          rutaCarga = 'Postulaciones/Periodo_P0042/Beca_ID_' + localStorage.getItem('localIdBeca') + '/Req.General/'
            + localStorage.getItem('ciUsuario') + '_TipoBeca_' + objPostula.idBeca + '_ReqGeneral_' + objPostula.idRequisito + '.pdf';
        else
          rutaCarga = 'Postulaciones/Periodo_P0042/Beca_ID_' + objPostula.idBeca + '/Req.Especifico/'
            + localStorage.getItem('ciUsuario') + '_Beca_' + objPostula.idBeca + '_ReqEspecifico_' + objPostula.idRequisito + '.pdf';

        objPostula.valorDoc = rutaCarga;
        const file = evento.target.files[0];
        if (file) {
          let formArchivo = new FormData();
          formArchivo.append('idAplicacion', this.recBecas.idAplicacion);
          formArchivo.append('idCredencial', "1");
          formArchivo.append('activo', "true");
          formArchivo.append('ruta', rutaCarga);
          formArchivo.append('file', file);

          await this.srvInsert.subirArchivos(formArchivo, this.tokenDrive).subscribe(data => {
            if (data.success)
              this.guardarRequisito(objPostula, op, objPostula.lblEdita);
          });
        }
      }
      else
        this.alerti.error('La fecha de carga de documentos es posterior a la actual');
    } else
      this.alerti.error('Al momento no se encuentra disponible');
  }
}
